/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation AutoRateImportDelete($vendorAccountId: ID!) {
    AutoRateImportDelete(vendorAccountId: $vendorAccountId) {
        message
        status
    }
} 
`

